import { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from '@mui/material';
import { Close as CloseIcon, ArrowBack, ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type Props = {
	open: boolean;
	onClose: () => void;
	syncReport: AccessOffline | null;
};

export default function SyncReportModal(props: Props) {
	const [currentIndex, setCurrentIndex] = useState(0);
	const { open, onClose, syncReport } = props;
	const { t } = useTranslation();

	if (!syncReport || !syncReport.offlineItems) return null;

	const handleNext = () => {
		setCurrentIndex((prev) => (prev < syncReport.offlineItems.length - 1 ? prev + 1 : prev));
	};

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>
				Process Sync {syncReport.processSyncId}
				<IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<TableContainer component={Paper}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>QR</TableCell>
								<TableCell>{t('common:status')}</TableCell>
								<TableCell>{t('common:message')}</TableCell>
								<TableCell>{t('common:date_mov_sync')}</TableCell>
								<TableCell>{t('common:type')}</TableCell>
								<TableCell>{t('common:plate')}</TableCell>
								<TableCell>{t('common:user')}</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow>
								<TableCell>{syncReport.offlineItems[currentIndex].access.code}</TableCell>
								<TableCell
									sx={{
										color: syncReport.offlineItems[currentIndex].status !== 'success' ? 'red' : 'inherit',
									}}
								>
									{syncReport.offlineItems[currentIndex].status === 'success'
										? t('common:Exito')
										: syncReport.offlineItems[currentIndex].status.toUpperCase()}
								</TableCell>{' '}
								<TableCell>
									{syncReport.offlineItems[currentIndex].msgError === 'Sin errores'
										? ''
										: syncReport.offlineItems[currentIndex].msgError}
								</TableCell>
								<TableCell>
									{new Date(syncReport.offlineItems[currentIndex].movements.date)
										.toLocaleDateString('es-ES', {
											day: '2-digit',
											month: 'short',
											year: 'numeric',
										})
										.replace('.', '')}{' '}
									{new Date(syncReport.offlineItems[currentIndex].movements.date).toLocaleTimeString('es-ES', {
										hour: '2-digit',
										minute: '2-digit',
										hour12: false,
									})}
								</TableCell>{' '}
								<TableCell>
									{syncReport.offlineItems[currentIndex].movements.type === 'entry'
										? t('common:entry')
										: t('common:exit')}
								</TableCell>
								<TableCell>{syncReport.offlineItems[currentIndex].movements.plate}</TableCell>
								<TableCell>
									{syncReport.offlineItems[currentIndex].movements.userId.first_name}{' '}
									{syncReport.offlineItems[currentIndex].movements.userId.last_name}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
			<DialogActions>
				<IconButton onClick={handlePrev} disabled={currentIndex === 0}>
					<ArrowBack />
				</IconButton>
				<span>
					{currentIndex + 1} / {syncReport.offlineItems.length}
				</span>
				<IconButton onClick={handleNext} disabled={currentIndex === syncReport.offlineItems.length - 1}>
					<ArrowForward />
				</IconButton>
			</DialogActions>
		</Dialog>
	);
}
